import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledChartContainer, StyledChartLegendContainer} from './style'

export const DashboardProjectsPieChartSkeleton = () => {
    return (
        <Flexbox align="center" gap={6}>
            <StyledChartContainer>
                <Skeleton width={100} height={100} style={{borderRadius: '50%'}} />
            </StyledChartContainer>
            <Flexbox direction="column" gap={3}>
                {Array.from({length: 2}).map((_, index) => (
                    <StyledChartLegendContainer key={index}>
                        <Flexbox gap={2} align="center">
                            <Skeleton width={50} height={32} />

                            <Skeleton width={100} height={24} />
                        </Flexbox>
                    </StyledChartLegendContainer>
                ))}
            </Flexbox>
        </Flexbox>
    )
}
